import { UrlService } from '../../../../environments/urlService';
import { HttpClient, HttpContext } from '@angular/common/http';
import { InvestorContribution } from '../dto/InvestorContribution';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class InvestorContributionService {
  private readonly url;

  constructor(
    private urlService: UrlService,
    private http: HttpClient,
  ) {
    this.url = this.urlService.getFmsUrl() + 'fund-performance/investor-contribution';
  }

  create(list: InvestorContribution[], fundUUID: string, withInvestorDelete: boolean): Observable<void> {
    return this.http.post<void>(
      this.url, list,
      {
        params: { fundUUID, withInvestorDelete },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  update(dto: InvestorContribution): Observable<void> {
    return this.http.put<void>(
      this.url, dto,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  getByFund(fundUUID: string): Observable<InvestorContribution[]> {
    return this.http.get<InvestorContribution[]>(
      this.url,
      {
        params: { fundUUID },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  delete(uuid: string): Observable<void> {
    return this.http.delete<void>(
      this.url,
      {
        params: { uuid },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }
}
